import Vue from 'vue'
import Router from 'vue-router'
const home = r => require.ensure([], () => r(require('../pages/home')), 'el-home')
const login = r => require.ensure([], () => r(require('../pages/login')), 'el-login')
const placard = r => require.ensure([], () => r(require('../pages/placard')), 'el-placard')
const joinSimulation = r => require.ensure([], () => r(require('../pages/joinSimulation')), 'el-joinSimulation')
const openAccount = r => require.ensure([], () => r(require('../pages/account/openAccount-kf')), 'el-openAccount')
const openAccountHj = r => require.ensure([], () => r(require('../pages/account/openAccount-hj')), 'el-openAccount')
const openAccountHj02 = r => require.ensure([], () => r(require('../pages/account/openAccount-hj02')), 'el-openAccount')
const openAccountHj03 = r => require.ensure([], () => r(require('../pages/account/openAccount-hj03')), 'el-openAccount')
const openAccountSh = r => require.ensure([], () => r(require('../pages/account/openAccount-sh')), 'el-openAccount')
const openAccountWeb = r => require.ensure([], () => r(require('../pages/account/openAccount-web')), 'el-openAccount')
const deliveryGarden = r => require.ensure([], () => r(require('../pages/deliveryGarden/deliveryGarden')), 'el-deliveryGarden')
const videoPlayer = r => require.ensure([], () => r(require('../pages/videoPlayer/videoPlayer')), 'el-deliveryGarden')
const joinSimulationZs = r => require.ensure([], () => r(require('../pages/yjs/joinSimulation-zs')), 'el-joinSimulation')
const openPage = r => require.ensure([], () => r(require('../pages/openMiniProgram/openPage')), 'openMiniProgram')

// 适应微信公众号
const sltContestList1 = r => require.ensure([], () => r(require('../pages/sltContest/list1')), 'sltContest')
// 适应微信公众号

const sltContestList = r => require.ensure([], () => r(require('../pages/sltContest/list')), 'sltContest')
const sltContestRegister = r => require.ensure([], () => r(require('../pages/sltContest/register')), 'sltContest')
const sltContestInquiry = r => require.ensure([], () => r(require('../pages/sltContest/inquiry')), 'sltContest')
const sltContestReset = r => require.ensure([], () => r(require('../pages/sltContest/reset')), 'sltContest')
const sltContestApplication = r => require.ensure([], () => r(require('../pages/sltContest/application')), 'sltContest')
const sltContestSuccess = r => require.ensure([], () => r(require('../pages/sltContest/success')), 'sltContest')
const sltContestSuccess1 = r => require.ensure([], () => r(require('../pages/sltContest/success1')), 'sltContest')
const sltContestProcess = r => require.ensure([], () => r(require('../pages/sltContest/process')), 'sltContest')
const sltContestDetail = r => require.ensure([], () => r(require('../pages/sltContest/detail')), 'sltContest')
const gpqqContestApplication = r => require.ensure([], () => r(require('../pages/gpqqContest/application')), 'gpqqContest')
const gpqqContestDetail = r => require.ensure([], () => r(require('../pages/gpqqContest/detail')), 'gpqqContest')
const zbsContestApplication = r => require.ensure([], () => r(require('../pages/zbsContest/application.vue')), 'zbsContest')
const zbsContestApplicationO1 = r => require.ensure([], () => r(require('../pages/zbsContest/applicationO1.vue')), 'zbsContest')
const zbsContestLogin = r => require.ensure([], () => r(require('../pages/zbsContest/login.vue')), 'zbsContest')
const tradingRiskControlInformation = r => require.ensure([], () => r(require('../pages/tradingRiskControl/information.vue')), 'tradingRiskControl')
const tradingRiskControlImage = r => require.ensure([], () => r(require('../pages/tradingRiskControl/image.vue')), 'tradingRiskControl')
// const zbsContestAgreement = r => require.ensure([], () => r(require('../pages/zbsContest/agreement.vue')), 'zbsContest')
// const zbsContestSuccess = r => require.ensure([], () => r(require('../pages/zbsContest/success.vue')), 'zbsContest')
// const sltContestTime = r => require.ensure([], () => r(require('../pages/sltContest/time')), 'sltContest')

// 徽商期货预约开户H5
const yykh = r => require.ensure([], () => r(require('../pages/yykh/index.vue')), 'yykh')
const yszc = r => require.ensure([], () => r(require('../pages/yszc/yszc.vue')), 'yszc')
const fwtk = r => require.ensure([], () => r(require('../pages/fwtk/fwtk.vue')), 'fwtk')
// 直播中心 iframe页面
const liveIframe = r => require.ensure([], () => r(require('../pages/miniappH5/liveIframe')), 'liveIframe')
// 期货训练营
const qhxly = r => require.ensure([], () => r(require('../pages/qhxly/qhxly')), 'liveIframe')
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      name: 'home',
      path: '/',
      component: home,
      meta: {
        keepAlive: true,
        title: '培训预约系统'
      }
    },
    {
      name: 'login',
      path: '/login',
      component: login,
      meta: {
        title: '登录'
      }
    },
    {
      name: 'placard',
      path: '/placard',
      component: placard,
      meta: {
        title: '培训预约海报',
        isLogin: true // 直接进不会被路由拦截跳登录
      }
    },
    {
      name: 'joinSimulation',
      path: '/joinSimulation',
      component: joinSimulation,
      meta: {
        title: '徽商期货期权仿真大赛'
      }
    },
    {
      name: 'joinSimulation-zs',
      path: '/yjs/joinSimulation-zs',
      component: joinSimulationZs,
      meta: {
        title: '郑商所期权仿真大赛'
      }
    },
    {
      name: 'openAccount',
      path: '/openAccount',
      component: openAccount,
      meta: {
        title: '徽商期货预约开户'
      }
    },
    {
      name: 'openAccountHj',
      path: '/openAccountHj',
      component: openAccountHj,
      meta: {
        title: '徽商期货预约开户'
      }
    },
    {
      name: 'openAccountHj02',
      path: '/openAccountHj02',
      component: openAccountHj02,
      meta: {
        title: '徽商期货预约开户'
      }
    },
    {
      name: 'openAccountHj03',
      path: '/openAccountHj03',
      component: openAccountHj03,
      meta: {
        title: '徽商期货预约开户'
      }
    },
    {
      name: 'openAccountSh',
      path: '/openAccountSh',
      component: openAccountSh,
      meta: {
        title: '徽商期货预约开户'
      }
    },
    {
      name: 'openAccountWeb',
      path: '/openAccountWeb',
      component: openAccountWeb,
      meta: {
        title: '徽商期货预约开户'
      }
    },
    {
      name: 'deliveryGarden',
      path: '/deliveryGarden',
      component: deliveryGarden,
      meta: {
        title: '交割园地'
      }
    },
    {
      name: 'videoPlayer',
      path: '/videoPlayer',
      component: videoPlayer,
      meta: {
        title: '视频播放'
      }
    },
    {
      name: 'openPage',
      path: '/openPage',
      component: openPage,
      meta: {
        title: '徽商期货小程序'
      }
    },
    // 适应微信公众号
    {
      name: 'sltContestList1',
      path: '/sltContest/list1',
      component: sltContestList1,
      meta: {
        title: '徽商期货模拟交易'
      }
    },
    // 适应微信公众号
    {
      name: 'sltContestList',
      path: '/sltContest/list',
      component: sltContestList,
      meta: {
        title: '徽商期货模拟交易'
      }
    },
    {
      name: 'sltContestRegister',
      path: '/sltContest/register',
      component: sltContestRegister,
      meta: {
        // isAuth: true,
        title: '徽商期货模拟交易账号注册'
      }
    },
    {
      name: 'sltContestInquiry',
      path: '/sltContest/inquiry',
      component: sltContestInquiry,
      meta: {
        // isAuth: true,
        title: '徽商期货模拟交易账号查询'
      }
    },
    {
      name: 'sltContestReset',
      path: '/sltContest/reset',
      component: sltContestReset,
      meta: {
        // isAuth: true,
        title: '徽商期货模拟交易账号密码重置'
      }
    },
    {
      name: 'sltContestApplication',
      path: '/sltContest/application',
      component: sltContestApplication,
      meta: {
        // isAuth: true,
        title: '徽商期货模拟交易大赛报名'
      }
    },
    {
      name: 'sltContestSuccess',
      path: '/sltContest/success',
      component: sltContestSuccess,
      props: true,
      meta: {
        title: '徽商期货模拟交易大赛注册成功'
      }
    },
    {
      name: 'sltContestSuccess1',
      path: '/sltContest/success1',
      component: sltContestSuccess1,
      props: true,
      meta: {
        title: '徽商期货模拟交易大赛查询成功'
      }
    },
    // {
    //   name: 'sltContestTime',
    //   path: '/sltContest/time',
    //   component: sltContestTime,
    //   meta: {
    //     title: '徽商期货模拟交易大赛还未开始'
    //   }
    // },
    {
      name: 'sltContestProcess',
      path: '/sltContest/process',
      component: sltContestProcess,
      meta: {
        title: '徽商期货模拟交易大赛流程'
      }
    },
    {
      name: 'sltContestDetail',
      path: '/sltContest/detail',
      component: sltContestDetail,
      meta: {
        title: '徽商期货模拟交易大赛详情'
      }
    },
    {
      name: 'gpqqContestApplication',
      path: '/gpqqContest/application',
      component: gpqqContestApplication,
      meta: {
        title: '股票期权模拟交易大赛报名'
      }
    },
    {
      name: 'gpqqContestDetail',
      path: '/gpqqContest/detail',
      component: gpqqContestDetail,
      meta: {
        title: '股票期权模拟交易大赛详情'
      }
    },
    {
      name: 'zbsContestApplication',
      path: '/zbsContest/application',
      component: zbsContestApplication,
      meta: {
        title: '模拟期货争霸赛注册并报名'
      }
    },
    {
      name: 'zbsContestApplicationO1',
      path: '/zbsContest/applicationO1',
      component: zbsContestApplicationO1,
      meta: {
        title: '金钥匙活动'
      }
    },
    {
      name: 'zbsContestLogin',
      path: '/zbsContest/login',
      component: zbsContestLogin,
      meta: {
        title: '模拟期货争霸赛登录报名'
      }
    },
    {
      name: 'tradingRiskControlInformation',
      path: '/tradingRiskControl/information',
      component: tradingRiskControlInformation,
      meta: {
        title: '交易风控资讯'
      }
    },
    {
      name: 'tradingRiskControlImage',
      path: '/tradingRiskControl/image',
      component: tradingRiskControlImage,
      meta: {
        title: '交易风控-期权交易图'
      }
    },
    {
      name: 'yykh',
      path: '/yykh/index',
      component: yykh,
      meta: {
        title: '徽商期货预约开户H5'
      }
    },
    {
      name: 'yszc',
      path: '/yszc/yszc',
      component: yszc,
      meta: {
        title: '隐私政策'
      }
    },
    {
      name: 'fwtk',
      path: '/fwtk/fwtk',
      component: fwtk,
      meta: {
        title: '服务条款'
      }
    },
    {
      name: 'liveIframe',
      path: '/miniappH5/liveIframe',
      component: liveIframe,
      meta: {
        title: '直播中心'
      }
    },
    {
      name: 'qhxly',
      path: '/qhxly/qhxly',
      component: qhxly,
      meta: {
        title: '期货训练营'
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 全局前置路由，配合浏览器localStorage进行鉴权操作
// router.beforeEach((to, from, next) => {
//   // 首先，我们先看一看to和from参数，next就是执行的意思，不写页面是不会跳转的
//   // console.log(to, from);
//   if (to.meta.isAuth) { // 判断是否需要鉴权
//     if (localStorage.getItem('name') === '张三') {
//       next()
//     } else {
//       next('/sltContest/time')
//     }
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js